import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./AddAdminModal.module.css";
import { useState } from "react";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for confirmation of removing an admin on the admins tab of the groups page.
 */

export function AddAdminModal({ isOpen, onClose, onClick, onSearch }) {
  const [input, setInput] = useState("");
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="ADD ADMIN"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.inputContainer}>
              <div className={styles.search} onClick={() => onSearch(input)}>
                <div className={styles.circle} />
                <div className={styles.handle} />
              </div>

              <input
                type="text"
                placeholder="User ID"
                className={styles.inputField}
                onChange={(e) => setInput(e.target.value)}
              />
              <div className={classNames(styles.bold, styles.lineHeight)}>
                User ID:
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button className={styles.button} onClick={() => onClick(input)}>
                CREATE ADMIN
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

AddAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  onSearch: PropTypes.func,
};
